import { CreateVideoType } from 'constant/videoTypes'
import { InstallExtensionFloating } from 'components/extension/InstallExtensionFloating'
import { UserType } from 'utils/common'
import useTranslation from '../../../hooks/useTranslation'

export const MemberTitle = (props: any) => {
  const { userInfo, createVideoType, isExtensionInstalled } = props
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center w-[343px] md:w-full md:relative">
      <InstallExtensionFloating
        userInfo={userInfo}
        isExtensionInstalled={isExtensionInstalled}
      />{' '}
      <h1 className="font-bold text-[32px] md:text-[40px]">
        {createVideoType === CreateVideoType.PRODUCT_SHORT
          ? t('productVideoEditor.memberTitle.createShortForm')
          : t('productVideoEditor.memberTitle.createProductVideo')}
      </h1>
      {createVideoType === CreateVideoType.PRODUCT_SHORT && (
        <>
          <a
            className="flex gap-2 items-center md:absolute md:right-0 md:top-[25%]"
            href="https://angelleague.notion.site/AI-15bba20e97f3809b8d33d7b08aaacd3f"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="assets/img/icon_youtube.png"
              alt="youtube"
              width={26}
              height={26}
            />{' '}
            <span className="font-bold">{t('productVideoEditor.memberTitle.checkFinalVersion')} {`>`}</span>
          </a>
        </>
      )}
      {createVideoType === CreateVideoType.PRODUCT_LONG && (
        <>
          <a
            className="flex gap-2 items-center md:absolute md:right-0 md:top-[25%]"
            href="https://angelleague.notion.site/AI-15bba20e97f3809b8d33d7b08aaacd3f"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="assets/img/icon_youtube.png"
              alt="youtube"
              width={26}
              height={26}
            />{' '}
            <span className="font-bold">{t('productVideoEditor.memberTitle.viewSample')} {`>`}</span>
          </a>
        </>
      )}
    </div>
  )
}
